export const subscribePrices = () => {
  return `subscription subscribePrices ($raceID: ID!, $sourceTypes: [inputSourceType!]) {
    priceUpdates(raceId: $raceID, sourceTypes: $sourceTypes){
      updated,
      prices{
        tabNo,
        price,
        type,
        source
      }
    }
  }`
}

export const subscribeRaceUpdates = () => {
  return `subscription subscribeRaceUpdates ($raceID: ID!) {
    raceUpdated(raceId: $raceID) {
      id
      startTime
      class
      name
      distance
      trackCondition
      weather
      startTime
      status
      prizeMoney
      competitors {
        created
        tabNo
        barrier
        name
        jockey
        trainer
        age
        sex
        country
        margin
        scratched
        finalPosition
        scratchingType
      }
    }
  }`
}

export const subscribeAllRaces = () => {
  return `subscription subscribeAllRace ($raceID: ID!) {
    raceUpdated(raceId: $raceID) {
      id
      startTime
      status
    }
  }`
}
